import * as Getter from "../getter";
import * as Setter from "../setter";
export * from "./compose";
export * from "./extra/object";
export const lens = (getter, setter) => (Object.assign(Object.assign({}, getter), setter));
export const of = () => lens(Getter.of(), Setter.of());

